import { useEffect, useState } from 'react';
import { updateMetadata, updateFavicon } from '../utils/metadata';
import { REACT_APP_COUNTRY } from '../config';

interface Metadata {
    title: string;
    description: string;
}

interface MetadataConfig {
    [key: string]: Metadata;
}

export const metadataConfig: MetadataConfig = {
    // BR Routes
    'BR:/quote': {
        title: 'Preencha sua aplicação de seguro de vida',
        description: 'Solicite seu seguro de vida e garanta o futuro de quem é mais importante para você. Estamos ao seu lado em cada etapa.'
    },
    'BR:/application': {
        title: 'Preencha sua aplicação de seguro de vida',
        description: 'Solicite seu seguro de vida e garanta o futuro de quem é mais importante para você. Estamos ao seu lado em cada etapa.'
    },
    'BR:/confirmation': {
        title: 'Preencha sua aplicação de seguro de vida',
        description: 'Solicite seu seguro de vida e garanta o futuro de quem é mais importante para você. Estamos ao seu lado em cada etapa.'
    },
    'BR:/logalty': {
        title: 'Assinatura Digital - Seguro de Vida',
        description: 'Complete a assinatura digital da sua aplicação de seguro de vida.'
    },
    
    // MX Routes
    'MX:/quote': {
        title: 'Cotización de Seguro de Vida',
        description: 'Complete su aplicación de seguro de vida con Ole Life.'
    },
    'MX:/application': {
        title: 'Aplicación de Seguro de Vida',
        description: 'Complete su aplicación de seguro de vida con Ole Life.'
    },
    'MX:/confirmation': {
        title: 'Confirmación de Seguro de Vida',
        description: 'Confirme su aplicación de seguro de vida con Ole Life.'
    },
    'MX:/attachment': {
        title: 'Adjuntar Documentos - Seguro de Vida',
        description: 'Adjunte los documentos necesarios para su aplicación de seguro de vida.'
    },
    'MX:/logalty': {
        title: 'Firma Digital - Seguro de Vida',
        description: 'Complete la firma digital de su aplicación de seguro de vida.'
    },
    
    // INT Routes
    'INT:/quote': {
        title: 'Complete your life insurance application',
        description: 'Request your life insurance and secure the future of those who matter most to you. We are by your side every step of the way.'
    },
    'INT:/application': {
        title: 'Life Insurance Application',
        description: 'Complete your life insurance application with Ole Life.'
    },
    'INT:/confirmation': {
        title: 'Confirm your life insurance application',
        description: 'Confirm your life insurance application with Ole Life.'
    },
    'INT:/logalty': {
        title: 'Digital Signature - Life Insurance',
        description: 'Complete the digital signature of your life insurance application.'
    },
    
    // Common routes (no country prefix)
    '/congratulations': {
        title: '¡Solicitud Enviada con Éxito!',
        description: 'Tu solicitud de seguro de vida ha sido enviada exitosamente. Recibirás confirmación en las próximas 24 horas.'
    },
    '/rejection-reminder': {
        title: 'Recordatorio de Rechazo',
        description: 'Recordatorio sobre su solicitud de seguro de vida.'
    },
    '/signature-rejected': {
        title: 'Firma Rechazada',
        description: 'Su firma digital ha sido rechazada.'
    },

    default: {
        title: 'Ole Life - Insurance Solutions',
        description: 'Your trusted partner in life insurance solutions.'
    }
};

// Función para actualizar el metadata inicialmente (antes de que React se monte)
export const updateInitialMetadata = (): void => {
    const path = window.location.pathname;
    const configKey = `${REACT_APP_COUNTRY}:${path}`;
    const metadata = metadataConfig[configKey] || metadataConfig[path] || metadataConfig.default;
    updateMetadata(metadata.title, metadata.description);
};

export const useMetadata = (): void => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    useEffect(() => {
        // Actualizar el favicon según el país al cargar la aplicación
        updateFavicon(REACT_APP_COUNTRY);
        
        // Función para actualizar el metadata
        const updateMetadataForPath = () => {
            const path = window.location.pathname;
            // Crear la clave combinando país y ruta: 'COUNTRY:/path'
            const configKey = `${REACT_APP_COUNTRY}:${path}`;
            
            // Intentar encontrar metadata específico por país y ruta
            // Si no existe, intentar solo por ruta (para rutas comunes)
            // Si tampoco existe, usar default
            const metadata = metadataConfig[configKey] || metadataConfig[path] || metadataConfig.default;

            updateMetadata(metadata.title, metadata.description);
            setCurrentPath(path);
        };

        // Actualizar inmediatamente
        updateMetadataForPath();

        // Escuchar cambios en la ruta usando popstate (navegación del navegador)
        const handlePopState = () => {
            updateMetadataForPath();
        };

        // Escuchar cambios de ruta mediante un intervalo para detectar cambios programáticos
        const intervalId = setInterval(() => {
            if (window.location.pathname !== currentPath) {
                updateMetadataForPath();
            }
        }, 100);

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
            clearInterval(intervalId);
        };
    }, [currentPath]);
}; 